import React, { Component } from 'react'
import { Icon, Nav } from '@softwaredev_cegeka/stix-core'
import { NavLink } from 'react-router-dom'
import './sidebar.scss'
import ImpersonateOrganizationMenu from '../Menu/ImpersonateOrganizationMenu'
import { reverse } from 'src/routes/config'
import { UserDataContext } from 'src/components/auth/withAuth'
import {
    CATALOG_CRUD,
    CATEGORY_CRUD,
    isAllowed,
    MACRO_CRUD,
    PRODUCT_EDIT,
    PRODUCT_TEMPLATE_CRUD,
    RBAC_CRUD,
} from 'src/utils/authorization'

class Sidebar extends Component {
    static contextType = UserDataContext

    render() {
        const canCreateProductTemplate = isAllowed(
            this.context,
            PRODUCT_TEMPLATE_CRUD
        )
        const canCreateProduct = isAllowed(this.context, PRODUCT_EDIT)
        const canCreateCatalog = isAllowed(this.context, CATALOG_CRUD)
        const canCreateCategory = isAllowed(this.context, CATEGORY_CRUD)
        const isRBACAllowed = isAllowed(this.context, RBAC_CRUD)
        const canCreateMacro = isAllowed(this.context, MACRO_CRUD)
        const hasActions =
            canCreateProductTemplate ||
            canCreateProduct ||
            canCreateCatalog ||
            canCreateCategory
        return (
            <section className={'sidebar-sticky'}>
                <div className={'sidebar-header customer-select'}>
                    <div>
                        <ImpersonateOrganizationMenu />
                    </div>
                </div>
                {hasActions ? (
                    <Nav className={'vert-nav nav stix-vert-nav stix-nav'}>
                        <h2 className={'sidebar-header-title'}>Actions</h2>
                        {canCreateProductTemplate && (
                            <NavLink
                                to={reverse('productTemplate-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon
                                    icon="edit"
                                    title={'Create a product template'}
                                />
                            </NavLink>
                        )}
                        {canCreateCatalog && (
                            <NavLink
                                to={reverse('catalog-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon
                                    icon="grid"
                                    title={'Create a new catalog'}
                                />
                            </NavLink>
                        )}
                        {canCreateProduct && (
                            <NavLink
                                to={reverse('product-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon
                                    icon="edit"
                                    title={'Create a new product'}
                                />
                            </NavLink>
                        )}
                        {canCreateCategory && (
                            <NavLink
                                to={reverse('category-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon icon="list" title={'Create a category'} />
                            </NavLink>
                        )}
                        {isRBACAllowed && (
                            <NavLink
                                to={reverse('group-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon icon="users" title={'Create a group'} />
                            </NavLink>
                        )}
                        {canCreateMacro && (
                            <NavLink
                                to={reverse('macro-create')}
                                activeClassName="active"
                                className="stix-nav-link"
                            >
                                <Icon
                                    icon="lightbulb"
                                    title={'Create a macro'}
                                />
                            </NavLink>
                        )}
                    </Nav>
                ) : null}
            </section>
        )
    }
}

export default Sidebar
